// API Base URLs Configuration
// Dynamic URLs based on environment (prod, staging, dev)
export const BASE_URL = process.env.REACT_APP_LAMBDA_ENV === "prod" 
  ? `https://api.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/dashboard/`
  : `https://api.${process.env.REACT_APP_LAMBDA_ENV}.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/dashboard/`;

